import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from '@/app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { registerLocaleData, CommonModule } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';

import { MatSelectModule } from '@angular/material/select';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { NgxSliderModule } from 'ngx-slider-v2';
import { ChangesDialogComponent } from '@pages/camera-settings/changes-dialog/changes-dialog.component';
import { SelectionDialogComponent } from '@pages/camera-settings/selection-dialog/selection-dialog.component';
import { MatGenericFormFieldComponent } from '@pages/camera-settings/mat-generic-form-field/mat-generic-form-field.component';
import { MatGenericFormFieldDisabledComponent } from '@pages/camera-settings/mat-generic-form-field-disabled/mat-generic-form-field-disabled.component';
import { CameraSettingComponent } from '@pages/camera-settings/camera-setting.component';
import { CameraRealtimeMapComponent } from '@pages/camera-realtime-map/camera-realtime-map.component';
import { MainComponent } from '@modules/main/main.component';
import { HeaderInterceptor } from '@services/http-intercepter';
import { DemoMaterialModule } from '@modules/material.module';

import { GoogleMapsModule } from '@angular/google-maps';
import { CallbackFilter } from './pipes/callback-filter.pipe';
import { DeviceService } from './services/device.service';
import { GoogleDeviceMapComponent } from './pages/camera-realtime-map/google-map/google-device-map.component';
import { StreamViewerComponent } from './pages/camera-realtime-map/stream-viewer/stream-viewer.component';
import { CameraService } from './services/camera.service';
import { LoginComponent } from '@pages/login/login.component';
import { ForgotPasswordComponent } from '@pages/forgot-password/forgot-password.component';
import { ScrollIntoViewDirective } from './directives/scroll-into-view.directive';
import { SearchMenuComponent } from './pages/camera-realtime-map/search-menu/search-menu.component';
import { ReportComponent } from './pages/reports/report/report.component';
import { AgGridModule } from 'ag-grid-angular'; // Angular Grid Logic
import { ColDef } from 'ag-grid-community'; // Column Definitions Interface
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { PaginationComponent } from './pages/reports/report/pagination/pagination.component';
import { WebrtcfeedsComponent } from './pages/webrtcfeeds/webrtcfeeds.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    CameraSettingComponent,
    LoginComponent,
    ForgotPasswordComponent,
    CameraRealtimeMapComponent,
    SearchMenuComponent,
    ChangesDialogComponent,
    SelectionDialogComponent,
    CallbackFilter,
    MatGenericFormFieldComponent,
    MatGenericFormFieldDisabledComponent,
    GoogleDeviceMapComponent,
    ScrollIntoViewDirective,
    StreamViewerComponent,
    ReportComponent,
    PaginationComponent,
    WebrtcfeedsComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ScrollToModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    GoogleMapsModule,
    HttpClientJsonpModule,
    HttpClientModule,
    AgGridModule,
    NgxSliderModule,
    MatTableModule,
    MatSidenavModule, 
    MatFormFieldModule, 
    MatSelectModule, 
    MatButtonModule,
    DemoMaterialModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    MatPaginatorModule,
    FontAwesomeModule,
    MatSelectModule
  ],
  exports: [
    CameraRealtimeMapComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,

    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    },
    DeviceService,
    CameraService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
